import {
    ExecuteScriptMessage,
    ExecuteScriptReplyMessage,
    extendedScriptVars,
    scriptInputs, stripFunction
} from "./ExecuteScriptMessage.ts";

export type customRefScriptInputs = {
    elementId: string,
    ref?: HTMLElement,
    _script?: string,
    __scriptInputs?: Object
};

export class CustomRefMessage<T = any, I extends scriptInputs = customRefScriptInputs> extends ExecuteScriptMessage<T, I & customRefScriptInputs> {

    constructor(script: (vars: extendedScriptVars<T, I & customRefScriptInputs>) => T,
                public scriptInputs: I & customRefScriptInputs,
                handler: (message: ExecuteScriptReplyMessage<T>) => void = () => {
                }) {

        //mock vars
        // let rootRef, elementId, _script, __scriptInputs;
        super(({rootRef, elementId, _script, __scriptInputs}) => {
            const refs = (rootRef.shadowRoot || rootRef.container).querySelectorAll(`[${'myop-id'}='${elementId}']`);
            if (refs.length) {
                //  const ref = refs[0];

                //TODO : think about exposing "refs" and not only "ref"
                //for cases where the Ref has multiplate implementations

                // @ts-ignore
                __scriptInputs.ref = refs[0];

                const dynamicFunction = new Function(`return (${_script})(...arguments)`);
                return dynamicFunction(__scriptInputs);

                // @ts-ignore
                //return Function('ref', 'rootRef', ...Object.keys(__scriptInputs), _script!)(ref, rootRef, ...Object.values(__scriptInputs))
            }
            return null as T;
        }, handler);

        this.scriptInputs = {
            ...scriptInputs,
            //_script: stripFunction(script.toString()),
            _script: script.toString()
        };
    }
}
